import React from 'react';
import styled from 'styled-components';
import { Icon } from './icon';
import { Text, Box } from 'rebass/styled-components';
import { LoadingBar } from './loadingBar';
import SectionHeader from './shell/SectionHeader';

const Bar = styled(Box)`
  height: 50px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: ${(p) => p.theme.space[3]}px;
  box-sizing: border-box;
`;

const TitleText = styled(Text)`
  color: ${(p) => p.theme.colors.white};
  user-select: none;
`;

const Filler = styled(Box)`
  flex-grow: 1;
`;

type Props = {
  addRecord(): void;
  loading: boolean;
};

const RecordsHeader: React.FC<Props> = ({ addRecord, loading }) => {
  return (
    // The rounded frame is the whole Videos & Audio bucket (views/project.tsx), so no border here.
    <Box>
      <SectionHeader title="Videos & Audio" actionLabel="Add record" onAction={addRecord} />
      <LoadingBar loading={loading} />
    </Box>
  );
};

export default RecordsHeader;
